import { render, staticRenderFns } from "./Supplier.vue?vue&type=template&id=09fbf255&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./Supplier.vue?vue&type=script&lang=js"
export * from "./Supplier.vue?vue&type=script&lang=js"
import style0 from "./Supplier.vue?vue&type=style&index=0&id=09fbf255&prod&scoped=true&lang=css"
import style1 from "./Supplier.vue?vue&type=style&index=1&id=09fbf255&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fbf255",
  null
  
)

export default component.exports